import React, { useEffect, useState } from 'react';
import { ScrollArea as ScrollAreaPrimitive } from '@base-ui/react/scroll-area';

// Fluid Functionalism scroll area, on Base UI. A drawn thumb that rests out of
// the way and shows while hovering or scrolling. Touch uses the native
// scroller instead, so the physics stay the platform's. The edge fade is the
// edl-scroll-fade class on the viewport, not part of this component.

const TouchContext = React.createContext(false);

export function ScrollArea({
  orientation = 'vertical',
  viewportClassName,
  contentClassName,
  contentStyle,
  viewportRef,
  className,
  children,
  ...props
}) {
  const touch = useTouchPrimary();
  const viewportClass = ['edl-scroll-area__viewport', viewportClassName].filter(Boolean).join(' ');

  if (touch) {
    return (
      <div {...props} className={['edl-scroll-area', className].filter(Boolean).join(' ')} data-orientation={orientation}>
        <div ref={viewportRef} className={viewportClass} data-orientation={orientation}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <TouchContext.Provider value={touch}>
      <ScrollAreaPrimitive.Root {...props} className={['edl-scroll-area', className].filter(Boolean).join(' ')}>
        <ScrollAreaPrimitive.Viewport ref={viewportRef} className={viewportClass}>
          <ScrollAreaPrimitive.Content className={contentClassName} style={contentStyle}>{children}</ScrollAreaPrimitive.Content>
        </ScrollAreaPrimitive.Viewport>
        {orientation !== 'horizontal' && <ScrollBar orientation="vertical" />}
        {orientation !== 'vertical' && <ScrollBar orientation="horizontal" />}
        {orientation === 'both' && <ScrollAreaPrimitive.Corner className="edl-scroll-area__corner" />}
      </ScrollAreaPrimitive.Root>
    </TouchContext.Provider>
  );
}

export function ScrollBar({ orientation = 'vertical', className, ...props }) {
  const touch = React.useContext(TouchContext);
  if (touch) return null;
  return (
    <ScrollAreaPrimitive.Scrollbar
      {...props}
      orientation={orientation}
      className={['edl-scroll-area__bar', className].filter(Boolean).join(' ')}
    >
      <ScrollAreaPrimitive.Thumb className="edl-scroll-area__thumb" />
    </ScrollAreaPrimitive.Scrollbar>
  );
}

function useTouchPrimary() {
  const [touch, setTouch] = useState(false);
  useEffect(() => {
    const query = window.matchMedia('(hover: none) and (pointer: coarse)');
    const apply = () => setTouch(query.matches);
    apply();
    query.addEventListener('change', apply);
    return () => query.removeEventListener('change', apply);
  }, []);
  return touch;
}
